import React from 'react';
import { Box, FormControlLabel, Checkbox, Button } from '@mui/material';
import StringFilter, { StringFilterState } from '../StringFilter/StringFilter';
import { useTranslation } from 'react-i18next';

export interface FiltersBarProps {
  dropdownFilters: {
    title: string;
    allSelectedTitle: string;
    state: StringFilterState;
    setState: React.Dispatch<React.SetStateAction<StringFilterState>>;
    sortAlphabetically?: boolean;
  }[];
  checkbox: {
    isChecked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    label: string;
  };
  applyFilters: () => void;
  clearFilters: () => void;
  customFilterNode?: React.ReactNode;
}

const FiltersBar: React.FC<FiltersBarProps> = ({
  dropdownFilters,
  checkbox,
  applyFilters,
  clearFilters,
  customFilterNode
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: '1fr 1fr',
          lg: '1fr 1fr 1fr 1fr'
        },
        gridGap: '20px',
        paddingBottom: '20px'
      }}
    >
      {customFilterNode && (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {customFilterNode}
        </Box>
      )}
      {dropdownFilters.map((filter, index) => (
        <Box key={index} sx={{ display: 'flex', flexDirection: 'column' }}>
          <StringFilter
            title={filter.title}
            allSelectedTitle={filter.allSelectedTitle}
            state={filter.state}
            setState={filter.setState}
            sortAlphabetically={filter.sortAlphabetically}
          />
          {index === dropdownFilters.length - 1 && checkbox && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkbox.isChecked}
                  onChange={checkbox.onChange}
                  name={checkbox.name}
                  sx={{
                    color: 'rgb(51, 51, 51)',
                    paddingLeft: '0'
                  }}
                />
              }
              label={checkbox.label}
              sx={{ whiteSpace: 'nowrap', marginTop: '10px', marginLeft: 0 }}
            />
          )}
        </Box>
      ))}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '40px'
        }}
      >
        <Box>
          <Button
            onClick={applyFilters}
            variant="contained"
            sx={{
              textTransform: 'none',
              width: '100%',
              minHeight: '40px'
            }}
          >
            {t('common.applyFilters')}
          </Button>

          <Button
            onClick={clearFilters}
            variant="outlined"
            sx={{
              textTransform: 'none',
              width: '100%',
              minHeight: '40px',
              marginTop: '10px'
            }}
          >
            {t('common.clearFilters')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default FiltersBar;
